import {ActivatedRouteSnapshot, CanActivateFn, GuardResult, MaybeAsync, RouterStateSnapshot} from "@angular/router";
import {inject} from "@angular/core";
import {productHandlingStore} from "../../dashboard-page/components/product-handling/store/product-handling.store";

export const productEditHandlingGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> => {
    const id = Number(route.paramMap.get('id'));
    return id !== undefined
        ? inject(productHandlingStore).fetchForEdit(id)
        : false;
}